import * as Moment from "moment";
import { IOcojoRepository, IOcojoImageSource } from "../../../domain/ocojo";
import { IOcojoImageHeaderBean } from "./beans/IOcojoImageHeaderBean";
import { DateDuration } from "../../../domain/system";
import { OcojoImageSource } from ".";
import { ImageSourceKinds } from "../../../domain/document";
import { AuthenticatedService } from "../../../infrastructure";
import { IOcojoImageStockable } from "../IOcojoImageStockable";

export class OcojoRepository extends AuthenticatedService implements IOcojoRepository, IOcojoImageStockable {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getPatientRelatedOcojoImages(patientId: string, duration: DateDuration, departmentId: string, orderNo: string): Promise<IOcojoImageSource[]> {
    if (!patientId || patientId === "") { throw new Error("id is empty!!!"); }
    const url = "/api/patient/" + patientId + "/ocojo/headers";
    const query = {
      params: {
        token: this.token,
        startDate: this.toDateText(duration ? duration.from : null),
        endDate: this.toDateText(duration ? duration.to : null),
        orderNo,
        departmentCode: departmentId,
      }
    };
    const result = await this.get(url, query);
    const converted = this.toOcojoImageSources(patientId, result.data);
    this.stock(converted);
    return this.toOcojoImageSources(patientId, result.data);
  }

  private toDateText(value: Date): string {
    if (!value) { return null; }
    // yyyyMMdd
    const year = value.getFullYear();
    const month = ("0" + (value.getMonth() + 1)).slice(-2);
    const date = ("0" + value.getDate()).slice(-2);
    return year + month + date;
  }

  private toOcojoImageSources(patientId: string, beans: IOcojoImageHeaderBean[]): IOcojoImageSource[] {
    const results: IOcojoImageSource[] = [];
    for (const bean of beans) {
      const imageSource = this.toOcojoImageSource(patientId, bean);
      results.push(imageSource);
    }
    return results;
  }

  private toOcojoImageSource(patientId: string, bean: IOcojoImageHeaderBean): IOcojoImageSource {
    return new OcojoImageSource(
      () => this.token,
      patientId,
      (bean.imageId != null) ? bean.imageId.toString() : null,
      null,
      ImageSourceKinds.Cache,
      !!bean.isMovie,
      !!bean.isLeft,
      !!bean.isRight,
      !!bean.isSecret,
      bean.departmentCode,
      false,
      this.toDate(bean.imageDate),
      bean.imageKind,
    );
  }

  private toDate(imageDate: string): Date {
    if (!imageDate) { return null; }
    // 現状ではバックエンドでyyyyMMddを指定している
    return Moment(imageDate, "YYYYMMDD").toDate();
  }

  private stock(source: IOcojoImageSource[]): void {
    for (const s of source) {
      if (!this._stocked[s.patientId]) {
        this._stocked[s.patientId] = {};
      }
      this._stocked[s.patientId][s.claioImageKey] = s;
    }
  }

  private readonly _stocked: { [key: string]: { [key: string]: IOcojoImageSource } } = {};

  public getStockedOcojoImage(patientId: string, imageId: string): IOcojoImageSource {
    if (!patientId) {
      throw new Error("patientId is empty!!!");
    }
    if (!imageId) {
      throw new Error("imageId is empty!!!");
    }
    return this._stocked[patientId]
      ? this._stocked[patientId][imageId]
      : null;
  }
}
